import React from 'react';
import ImageWithSkeleton from '../customImageComponent';
import exitPatient from '../../assets/SVG/exitPatient.svg';
import DefaultImageMale from '../../assets/SVG/Default Profile - Male.svg';
import DefaultImageFemale from '../../assets/SVG/Default Profile - Female.svg';
import styles from './sidebarComponent.module.css';

interface PatientContextHeaderProps {
  photo?: string | null;
  gender?: string | null;
  label: string;
  onExit: () => void;
  onAvatarClick: () => void;
}

const PatientContextHeader: React.FC<PatientContextHeaderProps> = ({ photo, gender, label, onExit, onAvatarClick }) => {
  return (
    <div className='d-flex' style={{ alignItems: 'center' }}>
      <div onClick={onExit}>
        <img src={exitPatient} alt="exitPatient" width={'25px'} />
      </div>

      <div className={styles.userCard} onClick={onAvatarClick}>
        <ImageWithSkeleton
          src={photo || undefined}
          alt={'pc'}
          fallbackSrc={gender === 'FEMALE' ? DefaultImageFemale : DefaultImageMale}
          height={'2rem'}
          width={'2rem'}
          borderRadius={'50%'}
        />
      </div>

      <div style={{ paddingLeft: '0.5rem' }} onClick={onExit}>
        <p>{label}</p>
      </div>
    </div>
  );
};

export default PatientContextHeader;
